import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H6 } from 'foundations-components/transitional/components/H6';
import { H2 } from 'foundations-components/transitional/components/H2';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { ScrollingColumns } from 'foundations-components/transitional/components/ScrollingColumns';
import { useDeferredValue, useEffect, useMemo, useState } from 'react';
import { getDisplayParamsDataColumns } from 'reporting-data/report/configReportGetters';
import PropertyOptionsPanel from './PropertyOptionsPanel';
import SelectedPropertiesPanel from './SelectedPropertiesPanel';
import { isReportValidForDataColumnsModal } from './utils';
import useFetchUserInfo from '../../hooks/useFetchUserInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DataColumnsButton = ({
  dataColumnsFromReport,
  setIsModalOpen
}) => {
  return /*#__PURE__*/_jsx(Button, {
    use: "tertiary",
    size: "extra-small",
    onClick: () => {
      setIsModalOpen(true);
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.data-columns-modal.config.selectedProperties",
      options: {
        count: dataColumnsFromReport.length
      }
    })
  });
};
const ConfigReportDataColumnsModal = ({
  report,
  onChange
}) => {
  var _getDisplayParamsData3, _getDisplayParamsData4;
  const userInfo = useFetchUserInfo();
  const [localReport, onSetLocalReport] = useState(report);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search, setSearch] = useState('');
  const deferredSearch = useDeferredValue(search);
  const dataColumnsFromReport = useMemo(() => {
    var _getDisplayParamsData, _getDisplayParamsData2;
    return ((_getDisplayParamsData = getDisplayParamsDataColumns(report)) === null || _getDisplayParamsData === void 0 || (_getDisplayParamsData2 = _getDisplayParamsData.toJS) === null || _getDisplayParamsData2 === void 0 ? void 0 : _getDisplayParamsData2.call(_getDisplayParamsData)) || [];
  }, [report]);
  const dataColumnsFromLocalReport = ((_getDisplayParamsData3 = getDisplayParamsDataColumns(localReport)) === null || _getDisplayParamsData3 === void 0 || (_getDisplayParamsData4 = _getDisplayParamsData3.toJS) === null || _getDisplayParamsData4 === void 0 ? void 0 : _getDisplayParamsData4.call(_getDisplayParamsData3)) || [];
  const onCloseModal = () => {
    setIsModalOpen(false);
    onSetLocalReport(report);
  };
  useEffect(() => {
    onSetLocalReport(report);
  }, [report]);
  if (!isReportValidForDataColumnsModal(report, userInfo || {
    gates: [],
    portal: {},
    user: {
      scopes: []
    }
  })) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isModalOpen && /*#__PURE__*/_jsxs(Modal, {
      width: 850,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "report-customization-components.customization-components.data-columns-modal.config.label"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onCloseModal
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(ScrollingColumns, {
          leftColumnHeader: /*#__PURE__*/_jsx(SearchInput, {
            placeholder: I18n.text('report-customization-components.customization-components.data-columns-modal.config.selectProperties'),
            onChange: ({
              target: {
                value: updatedValue
              }
            }) => {
              setSearch(updatedValue);
            },
            value: search
          }),
          leftColumnContent: /*#__PURE__*/_jsx(PropertyOptionsPanel, {
            report: localReport,
            onChange: onSetLocalReport,
            searchValue: deferredSearch
          }),
          rightColumnHeader: /*#__PURE__*/_jsx(H6, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "report-customization-components.customization-components.data-columns-modal.config.selectedProperties",
              options: {
                count: dataColumnsFromLocalReport.length
              }
            })
          }),
          rightColumnContent: /*#__PURE__*/_jsx(SelectedPropertiesPanel, {
            report: localReport,
            onChange: onSetLocalReport
          })
        })
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: () => {
            onChange(localReport);
            setIsModalOpen(false);
          },
          type: "submit",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "report-customization-components.customization-components.data-columns-modal.config.apply"
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          onClick: onCloseModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "report-customization-components.customization-components.data-columns-modal.config.cancel"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.data-columns-modal.config.tooltip"
      }),
      children: /*#__PURE__*/_jsx(DataColumnsButton, {
        dataColumnsFromReport: dataColumnsFromReport,
        setIsModalOpen: setIsModalOpen
      })
    })]
  });
};
export default ConfigReportDataColumnsModal;